import { render } from "./AssignToTeamModal.vue?vue&type=template&id=b77afe72&ts=true"
import script from "./AssignToTeamModal.vue?vue&type=script&lang=ts"
export * from "./AssignToTeamModal.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__